import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Respuesta } from '../_models/shared/_index';
import { Plantilla } from '../_models/informes/plantilla';
import { ErrorService } from './error.service';

@Injectable()
export class PlantillasService {
	private getPlantillasByIdInformeUrl		= environment.rest + '/Plantillas/GetPlantillasgetPlantillasByIdInforme';
	private getUsuariosPermisosDefaultUrl	= environment.rest + '/Plantillas/GetUsuariosPermisosDefault';
	private addPlantillaUrl					= environment.rest + '/Plantillas/AddPlantilla';
	private deletePlantillaUrl				= environment.rest + '/Plantillas/DeletePlantilla';
	private editPlantillaUrl				= environment.rest + '/Plantillas/EditPlantilla';
	private getPlantillasUrl				= environment.rest + '/Plantillas/GetPlantillas';
	private getHijosFromCarpetaUrl			= environment.rest + '/Plantillas/GetHijosFromCarpeta';
	private getPlantillaByIdPlantillaUrl	= environment.rest + '/Plantillas/GetPlantillaByIdPlantilla';
	private moverPlantillaUrl				= environment.rest + '/Plantillas/MoverPlantilla';
	private moverPlantillaDeCarpetaUrl		= environment.rest + '/Plantillas/MoverPlantillaDeCarpeta';
	private getPlantillasTreeUrl			= environment.rest + '/Plantillas/GetPlantillasTree';

	private getArbolPlantillasUrl			= environment.rest + '/Plantillas/GetArbolPlantillas';
	private getParametrosPlantillaUrl		= environment.rest + '/Plantillas/GetParametrosPlantilla';
	private getUsuariosDelClienteUrl		= environment.rest + '/Plantillas/GetUsuariosDelCliente';

	private options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};

	constructor(private http: HttpClient, private errorService: ErrorService) {}

	getPlantillasByIdInforme(idInforme: number): any {
		return this.http
			.post<Respuesta>(
				this.getPlantillasByIdInformeUrl,
				{ idInforme: idInforme },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> getPlantillasByIdInforme`
					)
				)
			);
	}

	getPlantillaByIdPlantilla(idPlantilla: number): any {
		return this.http
			.post<Respuesta>(
				this.getPlantillaByIdPlantillaUrl,
				{ idPlantilla: idPlantilla },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> getPlantillaByIdPlantilla`
					)
				)
			);
	}

	getUsuariosPermisosDefault(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getUsuariosPermisosDefaultUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET -> getUsuariosPermisosDefault`
					)
				)
			);
	}

	addPlantilla(plantilla: Plantilla): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.addPlantillaUrl, { plantilla }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> addPlantilla`)
				)
			);
			
	}

	deletePlantilla(idPlantilla: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.deletePlantillaUrl, { idPlantilla }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> deletePlantilla`)
				)
			);
	}

	editPlantilla(plantilla: Plantilla): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.editPlantillaUrl, { plantilla }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> editPlantilla`)
				)
			);
	}

	getCarpetas(idInforme: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getPlantillasUrl, { idInforme }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getCarpetas`)
				)
			);
	}

	getHijosFromCarpeta(idCarpeta: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getHijosFromCarpetaUrl, { idCarpeta }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> getHijosFromCarpetaToDataSource`
					)
				)
			);
	}

	moverPlantilla(plantilla: Plantilla, idCarpetaNueva: number) {
		return this.http
			.post<Respuesta>(
				this.moverPlantillaUrl,
				{ plantilla, idCarpetaNueva },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> moverPlantilla`)
				)
			);
	}

	moverPlantillaDeCarpeta(idPlantilla: number, idCarpetaNueva: number) {
		return this.http
			.post<Respuesta>(
				this.moverPlantillaDeCarpetaUrl,
				{ idPlantilla, idCarpetaNueva },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> moverPlantillaDeCarpeta`)
				)
			);
	}

	getPlantillasTree(idTipoInforme: number) {
		return this.http
			.post<Respuesta>(
				this.getPlantillasTreeUrl,
				{ idTipoInforme },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getPlantillasTree`)
				)
			);
	}

	getArbolPlantillas(idInforme: number) {
		return this.http
			.post<Respuesta>(
				this.getArbolPlantillasUrl,
				{ idInforme },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getArbolPlantillas`)
				)
			);
	}

	getParametrosPlantilla(idPlantilla: number) {
		return this.http
			.post<Respuesta>(
				this.getParametrosPlantillaUrl,
				{ idPlantilla },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getParametrosPlantilla`)
				)
			);
	}

	getUsuariosDelCliente() {
		return this.http
			.post<Respuesta>(
				this.getUsuariosDelClienteUrl,
				{},
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getUsuariosDelCliente`)
				)
			);
	}

	////////////////////////////////////////////////

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
